var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page-sticky",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.status !== "stopped",
          expression: "status !== 'stopped'"
        }
      ],
      staticClass: "floating-player",
      attrs: { position: "bottom-right", offset: [16, 90] }
    },
    [
      _c(
        "q-fab",
        {
          attrs: {
            color: "primary",
            icon: _vm.getMainButton,
            "active-icon": "fas fa-times",
            direction: "up"
          }
        },
        [
          _c("q-fab-action", {
            staticClass: "white",
            attrs: { color: "positive", icon: _vm.getSecondaryButton },
            on: {
              click: function($event) {
                return _vm.playPausePlayer()
              }
            }
          }),
          _c("q-fab-action", {
            staticClass: "white",
            attrs: { color: "negative", icon: "fas fa-stop" },
            on: {
              click: function($event) {
                return _vm.stopPlayer()
              }
            }
          }),
          _c("q-fab-action", {
            staticClass: "white",
            attrs: { color: "secondary", icon: "fas fa-list" },
            on: {
              click: function($event) {
                return _vm.showPlayer()
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }